import { useEffect, useRef } from "react";

/**
 * Returns a ref that adds/removes the "in-view" class
 * based on IntersectionObserver visibility.
 * This triggers the glow animation on scroll (mobile-friendly).
 */
export function useGlowRef<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("in-view");
        } else {
          el.classList.remove("in-view");
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return ref;
}
